import { ReviewController } from "./Review"
import { BaseModel } from "../Generics/BaseModel"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { CategoryEntity } from "../Category/CategoryEntity"
import { AddtionalEntity } from "../Addtional/AddtionalEntity"
import { AddtionalStockEntity } from "../Addtional/AddtionalStockEntity"
import { Promotions } from "../Promotion/Promotions"
import { SelectionEntity } from "../Selection/SelectionEntity"
import { SelectionOptionStockEntity } from "../Selection/SelectionOptionStockEntity"
import { EProductOrderModeType } from "../../Enum/EProductOrderModeType"

export class CatalogProductEntity extends BaseModel {
  id: number

  name: string

  description: string

  valueBase: number

  status: EEnableStatusType

  iconUrl: string

  imageUrls: string[]

  imageAssetIds: number[]

  imagesChanged: boolean

  promotionsIds: number[]

  promotions: Promotions[]

  reviewController: ReviewController

  category: CategoryEntity | null

  categoryId: number

  allowedAddtionals: AddtionalEntity[]

  allowedAddtionalsIds: number[]

  additionalStocks: AddtionalStockEntity[]

  freeAllowedAddtionals: AddtionalEntity[]

  freeAllowedAddtionalsIds: number[]

  freeAddtionalsLimit: number

  allowedSelections: SelectionEntity[]

  allowedSelectionsIds: number[]

  optionStocks: SelectionOptionStockEntity[]

  tags: string[]

  hasStockControl: boolean

  stockQuantity: number

  needFulfillment: boolean

  hasPreparationTime: boolean

  preparationTimeMinutes: number

  productOrderMode: EProductOrderModeType

  reservationAllowedDays: number[]

  reservationAllowedTimes: string[]

  constructor(data: Partial<CatalogProductEntity> = {}) {
    super()

    this.id = data.id ?? -1

    this.name = data.name ?? ""

    this.description = data.description ?? ""

    this.status = data.status ?? EEnableStatusType.Active

    this.valueBase = data.valueBase ?? 0

    this.iconUrl = data.iconUrl ?? ""

    this.imageUrls = data.imageUrls ?? (this.iconUrl ? [this.iconUrl] : [])

    this.imageAssetIds = data.imageAssetIds ?? []

    this.imagesChanged = data.imagesChanged ?? false

    this.promotionsIds = data.promotionsIds ?? []

    this.promotions = (data.promotions ?? []).map((e) => new Promotions(e))

    this.categoryId = data.category?.id ?? data.categoryId ?? 0

    if (this.categoryId !== 0) {
      this.category = new CategoryEntity(data.category!)
    }

    this.allowedAddtionals = data.allowedAddtionals?.map((e) => new AddtionalEntity(e)) ?? []

    this.additionalStocks = data.additionalStocks?.map((e) => new AddtionalStockEntity(e)) ?? []

    this.freeAllowedAddtionals = data.freeAllowedAddtionals?.map((e) => new AddtionalEntity(e)) ?? []

    this.freeAddtionalsLimit = data.freeAddtionalsLimit ?? 0

    this.allowedSelections = data.allowedSelections?.map((e) => new SelectionEntity(e)) ?? []

    this.allowedSelectionsIds = data.allowedSelectionsIds ?? []

    this.optionStocks = data.optionStocks?.map((e) => new SelectionOptionStockEntity(e)) ?? []

    this.tags = data.tags ?? []

    this.hasStockControl = data.hasStockControl ?? false

    this.stockQuantity = data.stockQuantity ?? 0

    this.needFulfillment = data.needFulfillment ?? false

    this.hasPreparationTime = data.hasPreparationTime ?? false

    this.preparationTimeMinutes = data.preparationTimeMinutes ?? 0

    this.productOrderMode = data.productOrderMode ?? EProductOrderModeType.ImmediateOnly

    this.reservationAllowedDays = data.reservationAllowedDays ?? []

    this.reservationAllowedTimes = data.reservationAllowedTimes ?? []

    this.reviewController = new ReviewController(data.reviewController)
  }

  override beforeToJSON(): void | Promise<void> {
    this.allowedAddtionalsIds = this.allowedAddtionals.map((e) => e.id)

    this.freeAllowedAddtionalsIds = this.freeAllowedAddtionals.map((e) => e.id)

    this.allowedSelectionsIds = this.allowedSelections.map((e) => e.id)
  }

  canUse() {
    return this.status === EEnableStatusType.Active && (!this.hasStockControl || this.stockQuantity > 0)
  }
}
